(function(factory){
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function($, undefined){
    function getDates( d1, d2 ){
        var oneDay = 24*3600*1000;
        for (var d=[],ms=d1*1,last=d2*1;ms<last;ms+=oneDay){
        d.push( new Date(ms) );
        }
        return d;
    }

    function format(d) {
        return (d.getDate() < 10 ? '0' : '') + d.getDate() + '.' + ((d.getMonth() + 1) < 10 ? '0' : '') + (d.getMonth() + 1) + '.' + d.getFullYear();
    }

    function date(val) {
        var split = val.split('.');

        return new Date(split[2], (split[1] - 1), split[0]);
    }

    function utc_to_local(utc) {
        if (!utc) {
            return utc;
        }

        var local = new Date(utc.getTime() + (utc.getTimezoneOffset() * 60000));

        if (local.getTimezoneOffset() !== utc.getTimezoneOffset()) {
            local = new Date(utc.getTime() + (local.getTimezoneOffset() * 60000));
        }

        return local;
    }

    var datepickerPlugin = function(option){
        this.each(function(){
            var opts = $.extend({}, {
                fromDate: '.from',
                toDate: '.to',
                format: 'yyyy/mm/dd',
                beforeShowDay: beforeShowDay,
                endPick: function(toDate, fromDate) {}
            }, option);

            var $this = $(this),
                $fromInput = $this.find(opts.fromDate),
                $toInput = $this.find(opts.toDate),
                fromDateHasVal = $fromInput.val() !== '',
                toDateHasVal = $toInput.val() !== '';

            function beforeShowDay(d) {
                var fromDate = date($fromInput .val());
                var toDate = date($toInput.val());

                if (format(new Date(d)) === format(fromDate) || format(new Date(d)) === format(toDate)) {
                    return 'active';
                } else {
                    var arr = getDates( fromDate, toDate);
                    for(var i = 0; i < arr.length; i++) {
                        if (format(new Date(d)) === format(arr[i])) return 'selected';
                    }
                }

            }

            $this.find('.range').on('rangepicker.update', function() {
                var fromDate = date($fromInput .val());
                var toDate = date($toInput.val());
                if (!isNaN(fromDate.getTime()) && !isNaN(toDate.getTime())) {
                    $this.find('.range').datepicker('update', toDate)
                } else if (!isNaN(fromDate.getTime()) && isNaN(toDate.getTime())) {
                    $this.find('.range').datepicker('update', fromDate)
                } else {
                    $this.find('.range').datepicker('update')
                }
            });

            $this.find('.range').datepicker('destroy').datepicker(opts).on('changeDate', function(evt) {
                if (evt.date !== '') {
                    var fromDate = utc_to_local(date($fromInput.val()));

                    if (fromDateHasVal && !toDateHasVal && fromDate.getTime() <= new Date(evt.date).getTime()) {
                        $toInput.val(format(evt.date));

                        fromDateHasVal = true;
                        toDateHasVal = true;
                    } else {
                        $fromInput.val(format(evt.date));

                        if (fromDate.getTime() <= new Date(evt.date).getTime()) {
                            $toInput.val(' ')
                        }

                        fromDateHasVal = true;
                        toDateHasVal = false;
                    }

                    // Update to the new values
                    fromDate = utc_to_local(date($fromInput.val()));
                    var toDate = utc_to_local(date($toInput.val()));

                    opts.endPick({
                        fromDateText: $fromInput.val(),
                        toDateText: $toInput.val(),
                        fromDate: fromDate.getFullYear() + '-'+fromDate.getMonth()+'-'+fromDate.getDate(),
                        toDate: toDate.getFullYear() + '-'+toDate.getMonth()+'-'+toDate.getDate(),
                    });

                    $this.find('.range').datepicker('update', evt.date);
                } else {
                    var fromDate = utc_to_local(date($fromInput.val()));
                    var toDate = utc_to_local(date($toInput.val()));

                    opts.endPick({
                        fromDateText: $fromInput.val(),
                        toDateText: $toInput.val(),
                        fromDate: $fromInput.val() === '' ? '' : fromDate.getFullYear() + '-'+fromDate.getMonth()+'-'+fromDate.getDate(),
                        toDate: $toInput.val() === '' ? '' : toDate.getFullYear() + '-'+toDate.getMonth()+'-'+toDate.getDate(),
                    });
                }
            });

            function keyUpdateValue(dateVal, todate, fromDate, empty) {
                if (dateVal && !isNaN(dateVal.getTime()) && utc_to_local(opts.startDate).getTime() <= dateVal.getTime() && utc_to_local(opts.endDate).getTime() >= dateVal.getTime()) {
                    fromDateHasVal = todate;
                    toDateHasVal = fromDate;

                    $this.find('.range').datepicker('update', dateVal);
                    $this.find('.range').trigger({
                        type: 'changeDate',
                        date: dateVal
                    });
                } else if (empty) {
                    $this.find('.range').datepicker('update', '');
                    $this.find('.range').trigger({
                        type: 'changeDate',
                        date: ''
                    });
                }
            }

            $fromInput.on('blur keyup', function() {
                var fromDate = date($fromInput.val());

                keyUpdateValue(fromDate, false, false, $fromInput.val() === '');
            });

            $toInput.on('blur keyup', function() {
                var toDate = date($toInput.val());

                keyUpdateValue(toDate, true, false, $toInput.val() === '');
            });

            $fromInput.on('focus', function() {
                $(this).val('');
                $this.find('.range').trigger({
                    type: 'changeDate',
                    date: ''
                });
            });

            $toInput.on('focus', function() {
                $(this).val('');
                $this.find('.range').trigger({
                    type: 'changeDate',
                    date: ''
                });
            });
		});
    };

    $.fn.datepickerrange = datepickerPlugin;
}));
